import { RESIDENCE_CARD_DOCUMENT_TYPE_IDS } from "@/types/enum";

// File document types are stored as a CSV string of EAttachmentDocumentType IDs per file
// (e.g. "1,7"), aligned by index with the file list. See TalentFormCertificateFiles and
// caseMatchInfoSchema for the encoding convention.

// Returns residence-card type IDs (表/裏) that are assigned more than once across the whole
// certificate file set. Each residence card side may only be tagged on a single file, so any
// id appearing 2+ times (within one file or spread across files) is a duplicate.
export const findDuplicateResidenceCardTypeIds = (fileTypes: (string | null | undefined)[]): number[] => {
  const counts = new Map<number, number>();
  fileTypes.forEach((csv) => {
    if (!csv) return;
    String(csv)
      .split(",")
      .map((s) => Number(s.trim()))
      .filter((n) => !Number.isNaN(n))
      .forEach((id) => counts.set(id, (counts.get(id) ?? 0) + 1));
  });
  return RESIDENCE_CARD_DOCUMENT_TYPE_IDS.filter((id) => (counts.get(id) ?? 0) > 1);
};

export const DUPLICATE_RESIDENCE_CARD_TYPE_MESSAGE = "在留カードの表面／裏面が重複しています。";
